let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("baIA4")).then(() => parcelRequire('amDP4'));